import "../assets/Exit.css";
import { defineComponent as A, ref as C, useTemplateRef as T, computed as v, onUpdated as M, onMounted as R, openBlock as g, createElementBlock as K, unref as N, createBlock as D, resolveDynamicComponent as B, mergeProps as I } from "vue";
import { o as P } from "./index.72N0HVaZ.js";
import { a as e, b as h, A as q } from "./maps.ChaVcqWI.js";
import { u as F, h as H } from "./Text.vue_vue_type_style_index_0_lang.DKpnS2d4.js";
import { n as G, u as V } from "./useStore.Cko4vubE.js";
import { r as O } from "./useModal.CgbJKM9V.js";
import { _ as U, C as W, a as j, b as z, c as J, N as Q, d as X, e as Y, f as Z, g as tt, h as et, i as ot } from "./StickyImage.vue_vue_type_style_index_0_lang.BFm9tY8W.js";
import { p as _ } from "./parseToolData.o66wWUUl.js";
function nt(t) {
  return t.getRootNode() instanceof ShadowRoot;
}
function at(t) {
  return nt(t) ? t.getRootNode() : document;
}
function it(t) {
  if (!t) return;
  const a = t.querySelector(
    'input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])'
  );
  if (a instanceof HTMLElement && a.offsetParent !== null && a.getBoundingClientRect().width > 0)
    a.focus();
  else {
    const s = t.querySelector('[tabindex="-1"]');
    s instanceof HTMLElement && s.offsetParent !== null && s.getBoundingClientRect().width > 0 ? s.focus() : (t.setAttribute("tabindex", "0"), t.focus());
  }
}
function st(t) {
  if (!t) return () => {
  };
  const a = "$el" in t ? t.$el : t, s = at(a), p = (n) => {
    if (n.key !== "Tab") return;
    const r = Array.from(
      a.querySelectorAll(
        'input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])'
      )
    ).filter((d) => !d.hasAttribute("disabled") && d.offsetParent !== null), l = r[0], u = r[r.length - 1], i = s.activeElement;
    n.shiftKey ? i === l && (n.preventDefault(), u.focus()) : i === u && (n.preventDefault(), l.focus());
  };
  return a.addEventListener("keydown", p), p;
}
const rt = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction", "aria-label"], bt = /* @__PURE__ */ A({
  __name: "Popup",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(t, { expose: a, emit: s }) {
    const p = {
      [e.Circular]: U,
      [e.CustomImage]: W,
      [e.Fullscreen]: j,
      [e.FullscreenMini]: z,
      [e.LowerNotification]: J,
      [e.NotificationTab]: Q,
      [e.Sidebar]: X,
      [e.SideGradient]: Y,
      [e.Square]: Z,
      [e.SquareImage]: tt,
      [e.Sticky]: et,
      [e.StickyImage]: ot
    }, n = t, r = s, l = G(_({
      ...n,
      toolKind: h.Layer
    })), u = C(), i = T("rootEl");
    let d;
    const c = v(() => {
      const {
        language: o,
        deviceViewport: f
      } = n.context, {
        content: {
          modules: m
        },
        settings: {
          layout: y
        }
      } = n.tool, L = F(m), $ = H(m);
      return {
        language: o,
        device: f,
        steps: L,
        hasSteps: $,
        layout: y
      };
    }), S = v(() => c.value.layout.type !== e.Sticky && c.value.layout.type !== e.StickyImage && c.value.layout.type !== e.NotificationTab && c.value.layout.type !== e.LowerNotification && c.value.layout.type !== e.SideGradient), E = v(() => {
      var f;
      if (!n.tool.settings.layout)
        return null;
      const o = (f = n.tool.settings.layout) == null ? void 0 : f.type;
      return p[o];
    });
    function k() {
      var o;
      (o = u.value) == null || o.show();
    }
    function b() {
      var o;
      (o = u.value) == null || o.hide();
    }
    M(() => {
      V(_({
        ...n,
        toolKind: h.Layer
      }));
    }), R(() => {
      l.handlers.callHandler(q.Show);
    });
    function x() {
      l.handlers.reset(), O(), r("hidden"), i.value && i.value.removeEventListener("keydown", d);
    }
    function w() {
      !n.context.builderMode && i.value && S.value && (it(i.value), d = st(i.value));
    }
    return P("Escape", () => {
      r("hidden"), b();
    }, { target: i }), a({
      show: k,
      hide: b
    }), (o, f) => {
      var m, y;
      return g(), K("div", {
        ref_key: "rootEl",
        ref: i,
        class: "thn--tool thn--tool-popup",
        role: "dialog",
        "data-builder-mode": o.context.builderMode,
        "data-device": o.context.deviceViewport,
        "data-content-alignment": (m = o.tool.settings.layout) == null ? void 0 : m.contentAlignment,
        "data-layout-kind": (y = o.tool.settings.layout) == null ? void 0 : y.type,
        "data-text-direction": N(l).rtl ? "rtl" : "ltr",
        "aria-modal": "true",
        "aria-label": n.tool.name
      }, [
        (g(), D(B(E.value), I({
          ref_key: "componentRef",
          ref: u
        }, c.value, {
          "builder-mode": o.context.builderMode,
          onAfterLeave: x,
          onAfterEnter: w
        }), null, 16, ["builder-mode"]))
      ], 8, rt);
    };
  }
});
export {
  bt as _
};
//# sourceMappingURL=Popup.vue_vue_type_style_index_0_lang.DPw-1sSi.js.map
